<template>
  <div class="trezo-card mb-[25px]">
    <div class="trezo-card-header mb-[20px] flex items-center justify-between">
      <div class="trezo-card-title">
        <h5 class="mb-0">Top Creators</h5>
      </div>
      <div class="trezo-card-subtitle">
        <RouterLink
          to="/nft-marketplace/create-nft"
          class="inline-block relative ltr:pr-[13px] rtl:pl-[13px] leading-none transition-all hover:text-primary-500"
        >
          Browse All
          <i
            class="ri-arrow-right-s-line absolute top-1/2 -translate-y-1/2 ltr:-right-[8px] rtl:-left-[8px] text-[23px] -mt-px"
          ></i>
        </RouterLink>
      </div>
    </div>
    <div class="trezo-card-content">
      <div
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-[25px]"
      >
        <div class="bg-white dark:bg-[#0c1427] p-[10px] rounded-md">
          <img
            src="@/assets/images/nfts/creator1.jpg"
            class="rounded-md"
            alt="creator-image"
          />
          <div class="text-center -mt-[34px]">
            <div class="relative mb-[15px] inline-block">
              <img
                src="@/assets/images/nfts/user.gif"
                class="rounded-full inline-block w-[68px]"
                alt="user-image"
              />
              <img
                src="@/assets/images/nfts/verified2.svg"
                class="absolute bottom-0 ltr:right-0 rtl:left-0"
                alt="verified"
              />
            </div>
            <h3 class="text-md font-semibold mb-[8px]">Hunny Bunny</h3>
            <span class="block text-xs"> ITEMS: 3204 </span>
            <div
              class="h-[1px] bg-primary-50 dark:bg-[#172036] my-[15px]"
            ></div>
            <button
              type="button"
              class="inline-block rounded-[7px] py-[6px] px-[17px] font-medium md:text-md bg-primary-500 text-white transition-all hover:bg-primary-400"
            >
              Follow
            </button>
          </div>
        </div>
        <div class="bg-white dark:bg-[#0c1427] p-[10px] rounded-md">
          <img
            src="@/assets/images/nfts/creator2.jpg"
            class="rounded-md"
            alt="creator-image"
          />
          <div class="text-center -mt-[34px]">
            <div class="relative mb-[15px] inline-block">
              <img
                src="@/assets/images/nfts/user.gif"
                class="rounded-full inline-block w-[68px]"
                alt="user-image"
              />
              <img
                src="@/assets/images/nfts/verified2.svg"
                class="absolute bottom-0 ltr:right-0 rtl:left-0"
                alt="verified"
              />
            </div>
            <h3 class="text-md font-semibold mb-[8px]">Aristocrat</h3>
            <span class="block text-xs"> ITEMS: 5301 </span>
            <div
              class="h-[1px] bg-primary-50 dark:bg-[#172036] my-[15px]"
            ></div>
            <button
              type="button"
              class="inline-block rounded-[7px] py-[6px] px-[17px] font-medium md:text-md bg-primary-500 text-white transition-all hover:bg-primary-400"
            >
              Follow
            </button>
          </div>
        </div>
        <div class="bg-white dark:bg-[#0c1427] p-[10px] rounded-md">
          <img
            src="@/assets/images/nfts/creator3.jpg"
            class="rounded-md"
            alt="creator-image"
          />
          <div class="text-center -mt-[34px]">
            <div class="relative mb-[15px] inline-block">
              <img
                src="@/assets/images/nfts/user.gif"
                class="rounded-full inline-block w-[68px]"
                alt="user-image"
              />
              <img
                src="@/assets/images/nfts/verified2.svg"
                class="absolute bottom-0 ltr:right-0 rtl:left-0"
                alt="verified"
              />
            </div>
            <h3 class="text-md font-semibold mb-[8px]">Hooman Robotic</h3>
            <span class="block text-xs"> ITEMS: 4213 </span>
            <div
              class="h-[1px] bg-primary-50 dark:bg-[#172036] my-[15px]"
            ></div>
            <button
              type="button"
              class="inline-block rounded-[7px] py-[6px] px-[17px] font-medium md:text-md bg-gray-400 text-white transition-all hover:bg-gray-400"
            >
              Unfollow
            </button>
          </div>
        </div>
        <div class="bg-white dark:bg-[#0c1427] p-[10px] rounded-md">
          <img
            src="@/assets/images/nfts/creator4.jpg"
            class="rounded-md"
            alt="creator-image"
          />
          <div class="text-center -mt-[34px]">
            <div class="relative mb-[15px] inline-block">
              <img
                src="@/assets/images/nfts/user.gif"
                class="rounded-full inline-block w-[68px]"
                alt="user-image"
              />
              <img
                src="@/assets/images/nfts/verified2.svg"
                class="absolute bottom-0 ltr:right-0 rtl:left-0"
                alt="verified"
              />
            </div>
            <h3 class="text-md font-semibold mb-[8px]">Colorful Life</h3>
            <span class="block text-xs"> ITEMS: 2314 </span>
            <div
              class="h-[1px] bg-primary-50 dark:bg-[#172036] my-[15px]"
            ></div>
            <button
              type="button"
              class="inline-block rounded-[7px] py-[6px] px-[17px] font-medium md:text-md bg-primary-500 text-white transition-all hover:bg-primary-400"
            >
              Follow
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "TopCreators",
});
</script>
